import * as React from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Loading from "../components/loading";
import {gql} from "@apollo/client";
import {query} from "../lib/apollo";
import {Card, CardContent, Grid} from "@mui/material";
import theme from "../lib/theme";
import {toast} from "react-toastify";
export default function MarginUpdatesPage() {
    const [input, setInput] = React.useState("");
    const [loading, setLoading] = React.useState(false);

    React.useEffect(() => {
        document.title = "Bulk Margin Locks | DN";
    }, []);

    const handleSubmit = async () => {
        setLoading(true);
        const lines = input.trim().split("\n");
        const data = lines.map(line => {
            const columns = line.split("\t");
            return {
                publisher_id: columns[0],
                name: columns[1],
                margin_lock: columns[2],
                new_margin_lock: columns[3],
                gr1_lv: columns[4],
                gpa: columns[5],
                gpa_q: columns[6],
            };
        });

        if (data.length < 2) {
            toast.error("Please paste a valid table");
        } else if (data[0].publisher_id !== "publisher_id") {
            toast.error("Missing publisher_id column");
        } else if (data[0].name !== "name") {
            toast.error("Missing name column");
        } else if (data[0].margin_lock !== "margin_lock") {
            toast.error("Missing margin_lock column");
        } else if (data[0].new_margin_lock !== "New Margin Lock") {
            toast.error("Missing New Margin Lock column");
        } else if (data[0].gr1_lv !== "Gr 1 (LV)") {
            toast.error("Missing Gr 1 (LV) column");
        } else if (data[0].gpa !== "GPA") {
            toast.error("Missing GPA column");
        } else if (data[0].gpa_q !== "GPA (Q)") {
            toast.error("Missing GPA (Q) column");
        } else {
            data.shift(); // Remove header row
            const inp = data.map(row => ({
                publisher_id: parseInt(row.publisher_id),
                new_margin_lock: parseFloat(row.new_margin_lock),
                lv: row.gr1_lv,
                q: row.gpa_q,
            }));

            const q = gql`
                mutation m($input: [PublisherMarginLockUpdateInput!]!) {
                    publisherBulkUpdateMarginLocks(input: $input)
                }
            `;

            const r = await query(q, {input: inp});

            if (r && r.publisherBulkUpdateMarginLocks) {
                toast.success("Margin locks updated successfully");
                setInput('');
            }
        }



        setLoading(false);
    }

    return (
        <>
            <h2>Bulk Margin Locks</h2>

            {loading ? <Loading/> :
            <>
                Note: Paste from excel, include the following columns, separated by tabs and new lines: <br/>
                publisher_id	name	margin_lock	New Margin Lock	Gr 1 (LV)	GPA	GPA (Q)<br/>
                <br/>

                    <TextField
                        id="outlined-multiline-static"
                        label="Margins Data"
                        multiline
                        rows={10}
                        fullWidth={true}
                        placeholder={"Paste table here"}
                        value={input}
                        onChange={(e: any) => setInput(e.target.value)}
                    />
                <br/><br/>
                    <Button onClick={handleSubmit} autoFocus variant="contained">
                        Submit
                    </Button>
            </>}
        </>
    )
}
